import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { initTimePicker } from '../init/datetimepicker';

export default class ScheduleSlot extends Component {
  constructor(props) {
    super(props);
    this.state = { start: props.slot.start || '00:00', end: props.slot.end || '00:00' };
    this.onStartChanged = this.onChange.bind(this, 'start');
    this.onEndChanged = this.onChange.bind(this, 'end');
    this.onRowAction = this.onRowAction.bind(this);
    this.onStartRef = this.onInputRef.bind(this, 'start');
    this.onEndRef = this.onInputRef.bind(this, 'end');
    setTimeout(() => this.props.onSlotChange(this.props.index, this.stateSlot()), 100);
  }

  componentWillReceiveProps(nextProps) {
    if (_.isEqual(this.stateSlot(), nextProps.slot)) { return; }
    this.setState({ start: nextProps.slot.start || '00:00', end: nextProps.slot.end || '00:00' });
  }

  componentWillUnmount() {
    $([this.startRef, this.endRef]).off('dp.change');
  }

  onChange(field, selectedDate) {
    const formatted = selectedDate.format('HH:mm');
    const date = moment(formatted, 'HH:mm');
    if (field === 'start' && date.isAfter(moment(this.state.end, 'HH:mm'))) {
      this.setState({ end: formatted });
    } else if (field === 'end' && date.isBefore(moment(this.state.start, 'HH:mm'))) {
      this.setState({ start: formatted });
    }
    this.setState({ [field]: formatted });
    setTimeout(() => this.props.onSlotChange(this.props.index, this.stateSlot()), 100);
  }

  onRowAction() {
    switch (this.props.buttonType) {
      case 'trash': return this.props.onTrashClick(this.props.index);
      case 'plus': return this.props.onPlusClick();
      default: return null;
    }
  }

  onInputRef(field, ref) {
    if (!ref) { return; }
    this[`${field}Ref`] = ref;
    initTimePicker($(ref));
    $(ref).on('dp.change', ({ date }) => this.onChange(field, date));
  }

  stateSlot() {
    return _.pick(this.state, ['start', 'end']);
  }

  render() {
    const { buttonType } = this.props;
    return (
      <div className="row-item">
        <input
          type="text"
          className="input-from form-control timepicker-field"
          value={this.state.start}
          ref={this.onStartRef}
          onChange={() => 0}
        />
        <input
          type="text"
          className="input-to form-control timepicker-field"
          value={this.state.end}
          ref={this.onEndRef}
          onChange={() => 0}
        />
        <a className="btn-row-actions" tabIndex={0} role="button" onClick={this.onRowAction}>
          <i className={`fa fa-${buttonType}`} />
        </a>
      </div>
    );
  }
}

ScheduleSlot.propTypes = {
  slot: PropTypes.shape({ start: PropTypes.string, end: PropTypes.string }).isRequired,
  index: PropTypes.number.isRequired,
  buttonType: PropTypes.oneOf(['trash', 'plus']).isRequired,
  onTrashClick: PropTypes.func.isRequired,
  onPlusClick: PropTypes.func.isRequired,
  onSlotChange: PropTypes.func.isRequired,
};
